import { render, staticRenderFns } from "./IrrigationArea.vue?vue&type=template&id=067b3f87&scoped=true&"
import script from "./IrrigationArea.vue?vue&type=script&lang=ts&"
export * from "./IrrigationArea.vue?vue&type=script&lang=ts&"
import style0 from "./IrrigationArea.vue?vue&type=style&index=0&id=067b3f87&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b3f87",
  null
  
)

export default component.exports